import React from 'react';
import { MenuItem, withStyles } from '@material-ui/core';
import moment from 'moment';
import { observer, inject } from 'mobx-react';
import classNames from 'classnames';
import { Typography } from '../../../components/Wrappers';
import UserAvatar from '../../../components/UserAvatar';
import * as Icons from '@material-ui/icons';
import iconJump from '../../../images/Presense/Action/icon-jump.png';
import iconNoMovement from '../../../images/Presense/Action/icon-nomovement.png';
import iconNosignal from '../../../images/Presense/DeviceSignal/icon-nosignal.png';

class NewWarning extends React.PureComponent {
  async componentDidMount() {
    await this.props.router.getRouters();
  }

  accessibility = (activite) => {
    const { classes } = this.props;
    let result = '';
    switch (activite) {
      case 1:
      case 10:
      case 14:
      case 15:
      case 16:
      case 17:
        result = <Icons.LocalHotel className={classes.iconActivity} />;
        break;
      case 2:
        result = <Icons.AirlineSeatReclineNormal className={classes.iconActivity} />;
        break;
      case 3:
        result = <Icons.Accessibility className={classes.iconActivity} />;
        // result = <img src={iconGetUp} alt="getup" width="30" />;
        break;
      case 4:
        result = <Icons.DirectionsWalk className={classes.iconActivity} />;
        break;
      case 5:
        result = <Icons.DirectionsRun className={classes.iconActivity} />;
        break;
      case 6:
        result = <img src={iconJump} alt='jump' width='30' />;
        break;
      case 8:
        result = <Icons.BatteryAlert className={classes.iconActivity} />;
        break;
      case 9:
        result = <img src={iconNosignal} alt='nosignal' width='30' />;
        break;
      case 11:
        result = <img src={iconNoMovement} alt='nomovement' width='30' />;
        break;
      case 12:
        result = <Icons.Warning style={{ paddingTop: '2px' }} />;
        break;
      case 18:
        result = <Icons.ExploreOff className={classes.iconActivity} />;
        break;
      case 19:
        result = <Icons.Snooze className={classes.iconActivity} />;
        break;
      default:
        result = <Icons.Help className={classes.iconActivity} />;
        break;
    }
    return result;
  };

  render() {
    let { classes } = this.props;
    const { routers } = this.props.router.toJS();
    let { data, select } = this.props.logActivity.toJS();
    if (select) {
      data = (data || []).filter((val) => val.patient.id === select);
    }
    data.map((val) => {
      val.router = (routers || []).find((res) => res.serial === val.router) || null;
      return val;
    });
    return (
      <div className={classes.warningContrainer}>
        <div className={classes.profileMenuUser}>
          <Typography variant='h4' weight='medium'>
            Logs Activity
          </Typography>
          <Typography className={classes.profileMenuLink} component='a' color='secondary'>
            {data.length} Count
          </Typography>
        </div>
        {data.map((message) => (
          <MenuItem key={message.id} className={classes.messageNotification}>
            <div className={classes.messageNotificationSide}>
              <UserAvatar color={message.variant} activity={this.accessibility(message.activity)} />
              <Typography variant='caption' color='textSecondary'>
                {moment(message.time).format('L')}
                <br />
                {moment(message.time).format('h:mm:ss A')}
                {/* {moment(message.time).startOf('minute').fromNow()} */}
                {/* hour / minute */}
              </Typography>
            </div>
            <div className={classNames(classes.messageNotificationSide, classes.messageNotificationBodySide)}>
              <Typography weight='medium' gutterBottom>
                {message.action} | HN-{message.patient.hn}
              </Typography>
              <Typography color='textSecondary'>
                {message.patient.firstname} {message.patient.lastname} ({message.patient.age} ปี)
              </Typography>
              <Typography color='textSecondary'>router : {message.router ? message.router.name : '-'}</Typography>
            </div>
          </MenuItem>
        ))}
      </div>
    );
  }
}

const styles = (theme) => ({
  profileMenuUser: {
    display: 'flex',
    flexDirection: 'column',
    padding: theme.spacing.unit * 2,
  },
  profileMenuItem: {
    color: theme.palette.text.hint,
  },
  profileMenuIcon: {
    marginRight: theme.spacing.unit * 2,
    color: theme.palette.text.hint,
  },
  profileMenuLink: {
    fontSize: 16,
    textDecoration: 'none',
    '&:hover': {
      cursor: 'pointer',
    },
  },
  messageNotification: {
    height: 'auto',
    display: 'flex',
    borderTop: 'thin solid',
    borderColor: '#dad8d8',
    alignItems: 'center',
    // '&:hover, &:focus': {
    //   backgroundColor: theme.palette.background.light,
    // },
  },
  messageNotificationSide: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    marginRight: theme.spacing.unit * 2,
  },
  messageNotificationBodySide: {
    alignItems: 'flex-start',
    marginRight: 0,
  },
  sendMessageButton: {
    margin: theme.spacing.unit * 4,
    marginTop: theme.spacing.unit * 2,
    marginBottom: theme.spacing.unit * 2,
    textTransform: 'none',
  },
  sendButtonIcon: {
    marginLeft: theme.spacing.unit * 2,
  },
  warningContrainer: {
    //marginTop : theme.spacing.unit * 2,
    height: '100vh',
    // overflowY: 'scroll',
    overflow: 'auto',
    width: '100%',
    backgroundColor: '#fff',
  },
  iconActivity: {
    color: 'black',
    paddingTop: '6px',
  },
  textDateTime: {
    width: '120px',
  },
});

export const page = inject('logActivity', 'router')(observer(NewWarning));
export default withStyles(styles, { withTheme: true })(page);
